<div [hidden]="configuration.displayOnlyComposition">

    <div class="title_offer">

        <!-- Catalogues / Canaux utilisant l'offre -->

        @if((configuration.displayChannels && catalogsIncludingOffer.length > 0) || item.locales.length > 1 || isMine) {

            <div class="row marges infos infos_canaux">

                @if(configuration.displayChannels && catalogsIncludingOffer.length > 0) {

                    <div class="col_12">

                        @if(catalogsIncludingOffer.length) {

                            @if(channelsIncludingOffer.length) {

                                <p><strong>{{ (catalogsIncludingOffer.length > 1 ? 'offer.presence.plural.value' : 'offer.presence.value') | translate:{countCatalogsIncludingOffer: catalogsIncludingOffer.length} }}
                                    {{ (channelsIncludingOffer.length > 1 ? 'offer.presence.channelIncluding.plural.value' : 'offer.presence.channelIncluding.value') | translate:{countChannelsIncludingOffer: channelsIncludingOffer.length} }}</strong></p>

                                <mat-accordion>
                                    <mat-expansion-panel>
                                        <mat-expansion-panel-header>
                                            <mat-panel-title>
                                                <span>{{ 'channel.list.value' | translate }}</span>
                                            </mat-panel-title>
                                        </mat-expansion-panel-header>
                                        @for(channel of channelsIncludingOffer; track channel) {
                                            <div class="txt_offer">
                                                <p><strong>{{ 'channel.distributor.value' | translate }}</strong>
                                                    : {{ channel.society.name }}</p>
                                                <p><strong>{{ 'channel.value' | translate }}</strong>
                                                    : {{ getTranslatedChannelFields(channel)?.name }}</p>
                                            </div>
                                        }
                                    </mat-expansion-panel>
                                </mat-accordion>
                            }

                            @if(!channelsIncludingOffer.length) {

                                <span>{{ (catalogsIncludingOffer.length > 1 ? 'offer.presence.plural.value' : 'offer.presence.value') | translate:{countCatalogsIncludingOffer: catalogsIncludingOffer.length} }}</span>
                            }
                        }
                    </div>
                }

                @if(item.locales.length > 1) {

                    <div class="col_12 col_md_4">
                        <div class="form-group choice_language">
                            <label><strong>{{ 'offer.read.choiceLanguage.value' | translate }} :</strong></label>
                            <mat-select [(ngModel)]="locale" class="no_label" (ngModelChange)="onLocaleUpdated.emit(locale)">
                                @for(locale of item.locales; track locale) {
                                    <mat-option [value]="locale">
                                        {{ 'locale.'+locale+ '.value' | translate }}
                                    </mat-option>
                                }
                            </mat-select>
                        </div>
                    </div>
                }

                <!-- Date de création / Date de mise à jour -->

                @if(isMine) {

                    <div class="col_12">
                        <div class="row marges">
                            <div class="col_content y_items_center">
                                <span>{{'offer.list.item.createdAt.value' | translate}} - {{ item.createdAt | date:'full' : null : localeId }}</span>
                            </div>
                        </div>
                        <div class="row marges">
                            <div class="col_content y_items_center">
                                <span>{{'offer.list.item.updatedAt.value' | translate}} - {{ item.updatedAt | date:'full' : null : localeId }}</span>
                            </div>
                        </div>
                    </div>
                }

            </div>
        }

        <div class="row marges">

            <!-- Offre "Nouveauté" -->

            @if(item.isNew) {
                <div class="col_content y_items_center">
                    <span class="tag">{{'offer.list.item.new.value' | translate}}</span>
                </div>
            }

            <!-- Nom de l'offre -->

            <div class="col y_items_center">
                <p class="title">{{translatedItemFields?.name}}</p>
            </div>
        </div>

        <div class="row marges infos_price">
            <div class="col_8">

                <div class="row marges infos">

                    <div class="col_content y_items_center">

                        <!-- Créateur d'offre -->

                        <span>{{ 'offer.list.item.show.value' | translate }} : {{ item.society.name }}</span>

                    </div>

                    @if(item.reference) {

                        <div class="col_content y_items_center">

                            <!-- Référence -->

                            <span>{{ 'offer.reference.identifier.value' | translate }} : {{ item.reference }}</span>

                        </div>
                    }
                </div>

                <div class="row marges infos">

                    <div class="col_content y_items_center">

                        <!-- Type d'offre -->

                        <span class="offer_type ty-house">{{ translatedCustomerTypologyItemFields?.name }}</span>

                        <!-- Ville / Pays -->

                        @if(!item.enableMultipleMainLocation && item.firstLocation) {
                            <span>{{ item.firstLocation.city }}, {{ item.firstLocation.country }}</span>
                        }

                    </div>
                    <div class="col_content y_items_center">

                        <!-- Durée de l'offre -->

                        <span class="offer_type ty-calendar">{{ translatedDurationItemFields?.label }}</span>

                    </div>
                    <div class="col_content y_items_center">

                        <!-- Présentiel Adulte -->

                        @if(item.presential.adultMax > 0) {

                            <span>
                                {{ 'offer.presential.interval.value' | translate:{
                                        min: item.presential.adultMin,
                                        max: item.presential.adultMax
                                    } }} {{ (item.presential.adultMax > 1 ? 'offer.presential.adult.plural.value' : 'offer.presential.adult.value') | translate }}
                            </span>
                        } @else {
                            <span>{{ 'offer.presential.adult.void.value' | translate }}</span>
                        }

                        <span>,&nbsp;</span>

                        <!-- Présentiel Enfant -->

                        @if(item.presential.childMax) {

                            <span>
                                {{ 'offer.presential.interval.value' | translate:{
                                        min: item.presential.childMin,
                                        max: item.presential.childMax
                                    } }} {{ (item.presential.childMax > 1 ? 'offer.presential.child.plural.value' : 'offer.presential.child.value') | translate }}

                                @if(!item.onRequest && item.publics.includes('child')) {
                                    {{ 'offer.presential.child.age.interval.value' | translate :{min: item.minChildrenAge, max: item.maxChildrenAge} }}
                                }
                            </span>

                        } @else {
                            <span>{{ 'offer.presential.child.void.value' | translate }}</span>
                        }

                    </div>
                </div>

                <!-- Producteur de l'offre -->

                @if(configuration.displayOwner) {

                    <div class="row marges infos">
                        <div class="col_12">
                            <span>{{ item.society.name }} - {{ item.society.email }} - {{ item.society.phone }}</span>
                        </div>
                    </div>
                }

            </div>

            <div class="col_4">
                @if(formattedStartFromPriceTTC) {

                    <div class="row infos x_end">
                        <div class="col_content">
                            <div class="price">
                                <div class="price_info">
                                    <span class="from">{{ (item.catalog ? 'offer.startFromPrice.public.value' : 'offer.startFromPrice.net.value') | translate }}</span>
                                </div>
                                <div class="price_amount">
                                    <span class="price">{{ formattedStartFromPriceTTC }} {{ 'ttc.value' | translate }}</span>
                                    <span>{{ 'offer.list.item.perPerson.value' | translate }}</span>
                                </div>
                                @if(item.startFromPriceBasedOnParticipantCount) {
                                    <div class="price_info">
                                        <span class="participants">{{ 'offer.list.item.startFromPriceBasedOnParticipantCount.value' | translate: {count: item.startFromPriceBasedOnParticipantCount} }}</span>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                }
            </div>
            <!-- Signalement de l'offre -->
            @if(hasRole('ROLE_PROVIDER') || hasRole('ROLE_INSTITUTIONAL') || hasRole('ROLE_FEDERATION')) {

                <div class="col_content">
                    <button type="button" class="btn_cta btn_small" (click)="openSignalementDialog(item.id)">
                        <span class="ty-info">{{ 'offer.report.value' | translate }}</span>
                    </button>
                </div>
            }
        </div>

        @if(item.hashtags.length) {

            <div class="row marges">
                <div class="col_12">
                    <div class="hashtags">
                        @for(hashtag of parsedHashtags; track $index) {
                            <div class="hashtag"><img src="assets/images/hashtag.png" alt="hashtag"><span>{{ hashtag }}</span></div>
                        }
                    </div>
                </div>
            </div>
        }
    </div>

    <!-- Visuels -->

    @if(translatedItemFields?.pictures.length) {

        <div class="row offer_pictures">

            <!-- Visuel principal -->

            <div [ngClass]="{ 'col_6' : translatedItemFields.pictures.length > 1, 'col_12' : translatedItemFields.pictures.length <= 1 }" class="col_md_6 col_left">
                <img [src]="item | offerPictureSource: translatedItemFields.pictures[0] : 'rectangle' : (translatedItemFields.pictures.length > 1 ? 500 : 1000) : 90"/>
            </div>

            <!-- Visuels secondaires -->

            <div class="col_12 col_md_6 col_right">

                <div class="row h_full">

                    @if(translatedItemFields.pictures.length > 1) {

                        @for(picture of translatedItemFields.pictures.slice(1, countDefaultDisplayedPictures); track picture) {

                            <div class="col_6">

                                <img [src]="item | offerPictureSource: picture : 'rectangle' : 230 : 90"/>

                                @if($last && translatedItemFields.pictures.length <= countDefaultDisplayedPictures) {

                                    <div (click)="openPictureGalleryDialog()" class="see_more">
                                        <span>{{ 'offer.picture.open.value' | translate }}</span>
                                    </div>
                                }

                                @if($last && translatedItemFields.pictures.length > countDefaultDisplayedPictures) {

                                    <div (click)="openPictureGalleryDialog()" class="see_more">
                                        <span>{{ 'offer.picture.more.question.value' | translate }}</span>
                                    </div>
                                }

                            </div>
                        }
                    }

                </div>

            </div>


        </div>
    }

</div>

<!-- Composition -->

<ng-content select="[compositionContent]"></ng-content>

<div [hidden]="configuration.displayOnlyComposition">

    <div class="txt_offer">
        @if(translatedInterestsItemFields.length > 0) {
            <p class="title">{{ 'offer.form.fields.interests.title.value' | translate }}</p>
        }

        <p class="interest">

            <!-- Intérêts -->

            @for(interest of translatedInterestsItemFields; track $index) {
                <span>{{ interest.label }}</span><br/>
            }
        </p>
    </div>

    <!-- Description -->

    <div class="txt_offer">

        @if(translatedItemFields?.salesPitch) {

            <mat-accordion multi>

                <!-- Argumentaire de vente -->
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{ 'offer.salesPitch.value' | translate }}
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <p [innerHTML]="translatedItemFields?.salesPitch|safeHtml" class="argument"></p>

                </mat-expansion-panel>

            </mat-accordion>
        }

        <p class="title">{{ 'offer.description.value' | translate }}</p>

        <div [innerHTML]="translatedItemFields?.description|safeHtml" #descriptionContainer class="description_offer ck-content"></div>

        @if(isMoreElementEnabled(descriptionContainer, 84)) {
            <div class="see_more"><span (click)="moreElement(descriptionContainer)">{{ 'offer.readMore.value' | translate }}</span></div>
        }

    </div>

    <!-- Compris / Non compris dans l'offre -->

    <mat-accordion multi>

        <!-- Compris dans l'offre -->

        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    {{ 'offer.form.fields.included.value' | translate }}
                </mat-panel-title>
            </mat-expansion-panel-header>

            @for(included of translatedIncludedsItemFields; track $index) {
                <div class="txt_offer">
                    <p class="title_2">{{ included?.title }}</p>
                    <p>{{ included?.description }}</p>
                </div>
            }

        </mat-expansion-panel>

        <!-- Non Compris dans l'offre -->

        <mat-expansion-panel>

            <mat-expansion-panel-header>
                <mat-panel-title>
                    {{ 'offer.form.fields.included.no.value' | translate }}
                </mat-panel-title>
            </mat-expansion-panel-header>

            @for(included of translatedNotIncludedsItemFields; track $index) {
                <div class="txt_offer little">
                    <p class="title_2">{{ included?.title }}</p>
                    <p>{{ included?.description }}</p>
                </div>
            }

        </mat-expansion-panel>
    </mat-accordion>

    <!-- Hébergement -->

    @if(translatedItemFields?.accommodation?.length) {

        <div class="txt_offer">

            <p class="title">{{ 'offer.accommodation.value' | translate }}</p>

            <div [innerHTML]="translatedItemFields?.accommodation|safeHtml" #accommodationContainer class="accommodation_offer ck-content"></div>

            @if(isMoreElementEnabled(accommodationContainer, 84)) {
                <div class="see_more"><span (click)="moreElement(accommodationContainer)">{{ 'offer.readMore.value' | translate }}</span></div>
            }

        </div>
    }

    <!-- Prestataires -->

    @if(configuration.displayProviders && item.providerSocieties.length) {

        <div class="txt_offer">
            <p class="title">{{ 'role.provider.plural.value' | translate }}</p>

            @for(provider of item.providerSocieties; track provider) {
                <p>{{ provider.name }}</p>
            }
        </div>
    }

    <!-- Programme -->

    @if(translatedProgramsItemFields.length > 0) {

        <div>
            <div class="txt_offer">
                <p class="title">{{ 'offer.program.value' | translate}}</p>
            </div>

            <!-- Sélection du jour -->

            @if(translatedProgramsItemFields.length > 1) {

                <div class="nav_slider_program">
                    @for(program of translatedProgramsItemFields; track $index) {
                        <button type="button" class="btn_cta btn_small" (click)="setCurrentProgramDay($index)">
                            {{ $index + 1 }}
                        </button>
                    }
                </div>
            }

            <!-- Slider -->

            <div #swiper class="swiper-container slider_program" [ngClass]="{'not_pictures': !item.hasProgramsPictures}">
                <div class="swiper-wrapper">
                    @for(program of translatedProgramsItemFields; track $index) {

                        <div class="swiper-slide">
                            <ng-container>
                                @if(translatedProgramsItemFields.length > 1) {
                                    <span class="day">{{ 'day.value' | translate }} {{ $index + 1 }}</span>
                                }
                                <div class="row h_full content_program">
                                    <div [ngClass]="{'col_7': item.hasProgramsPictures}">
                                        <div class="info_program">
                                            <div class="txt_offer">
                                                <p><strong>{{ program?.title }}</strong></p>
                                                <div [innerHTML]="program?.description|safeHtml" class="ck-content"></div>
                                            </div>
                                        </div>
                                    </div>
                                    @if(item.hasProgramsPictures) {
                                        @if(program?.picture?.image?.image) {
                                            <div class="col_5">
                                                <img [src]="item.programs[$index] | offerProgramPictureSource: item : locale : 'portrait' : 500 : 90"/>
                                            </div>
                                        }
                                    }
                                </div>
                            </ng-container>
                        </div>
                    }
                    <div class="swiper-slide"></div>
                    @if(!item.hasProgramsPictures) {
                        <div class="swiper-slide"></div>
                    }
                </div>
                <div #swiperPagination class="swiper-pagination"></div>
            </div>
        </div>
    }

    <!-- Options -->

    <ng-content select="[optionsContent]"></ng-content>

    <!-- Localisation(s) -->

    @if(locations.length) {

        <div class="txt_offer">
            <div>
                <p class="title">{{ 'offer.location.value' | translate}}</p>
            </div>
            <div class="map_container" leaflet [leafletOptions]="mapOptions" [leafletFitBounds]="fitBounds" [leafletMarkerCluster]="markers" [leafletMarkerClusterOptions]="markerClusterOptions"></div>
        </div>
    }

    <!-- Transport -->

    @if(locations.length && (hasOfferLocationTransportByType('train-station') || hasOfferLocationTransportByType('airport'))) {

        <div class="txt_offer no_border">

            <p class="title">{{ 'offer.transport.title' | translate}}</p>

            @if(isStartLocationSameAsEndLocation) {

                <!-- Début / fin de programme -->

                <div class="transport_infos">

                    <p class="transport_moment"><strong>{{ 'offer.access.program.startAndEnd.value' | translate}}</strong></p>

                    @if(hasOfferLocationTransportByType('train-station')) {
                        <app-core-offer-location-transport-calculation-details [offerLocationTransport]="getOfferLocationTransport(true, true, 'train-station')" [displayTransportDuration]="item.displayTransportDuration"></app-core-offer-location-transport-calculation-details>
                    }

                    @if(hasOfferLocationTransportByType('train-station') && textLength(translatedItemFields.transportArrivalTrainStationDescription) > 0) {

                        <div class="advice" #startAdviceContainer>
                            <p class="underline"><strong>{{ 'offer.transport.advice' | translate}}</strong></p>
                            @if(textLength(translatedItemFields.transportArrivalTrainStationDescription) > transportDescriptionLimit) {
                                <div class="short ck-content" [innerHTML]="cropHtml(translatedItemFields.transportArrivalTrainStationDescription, transportDescriptionLimit)|safeHtml"></div>
                            }
                            <div class="long ck-content" [innerHTML]="translatedItemFields.transportArrivalTrainStationDescription|safeHtml"></div>
                            @if(textLength(translatedItemFields.transportArrivalTrainStationDescription) > transportDescriptionLimit) {
                                <p class="more" (click)="moreTransportInfos(startAdviceContainer)">{{ 'offer.transport.more' | translate}}</p>
                            }
                        </div>
                    }

                    @if(hasOfferLocationTransportByType('airport')) {
                        <app-core-offer-location-transport-calculation-details [offerLocationTransport]="getOfferLocationTransport(true, true, 'airport')" [displayTransportDuration]="item.displayTransportDuration"></app-core-offer-location-transport-calculation-details>
                    }

                    @if(hasOfferLocationTransportByType('airport') && textLength(translatedItemFields.transportArrivalAirportDescription) > 0) {

                        <div class="advice" #startAdviceContainer>
                            <p class="underline"><strong>{{ 'offer.transport.advice' | translate}}</strong></p>
                            @if(textLength(translatedItemFields.transportArrivalAirportDescription) > transportDescriptionLimit) {
                                <div class="short ck-content" [innerHTML]="cropHtml(translatedItemFields.transportArrivalAirportDescription, transportDescriptionLimit)|safeHtml"></div>
                            }
                            <div class="long ck-content" [innerHTML]="translatedItemFields.transportArrivalAirportDescription|safeHtml"></div>
                            @if(textLength(translatedItemFields.transportArrivalAirportDescription) > transportDescriptionLimit) {
                                <p class="more" (click)="moreTransportInfos(startAdviceContainer)">{{ 'offer.transport.more' | translate}}</p>
                            }
                        </div>
                    }

                </div>

            } @else {

                <!-- Début de programme -->

                <div class="transport_infos">

                    <p class="transport_moment"><strong>{{ 'offer.access.program.start.value' | translate}}</strong></p>

                    @if(hasOfferLocationTransportByType('train-station')) {
                        <app-core-offer-location-transport-calculation-details [offerLocationTransport]="getOfferLocationTransport(true, false, 'train-station')" [displayTransportDuration]="item.displayTransportDuration"></app-core-offer-location-transport-calculation-details>
                    }

                    @if(hasOfferLocationTransportByType('train-station') && textLength(translatedItemFields.transportArrivalTrainStationDescription) > 0) {

                        <div class="advice" #startAdviceContainer>
                            <p class="underline"><strong>{{ 'offer.transport.advice' | translate}}</strong></p>
                            @if(textLength(translatedItemFields.transportArrivalTrainStationDescription) > transportDescriptionLimit) {
                                <div class="short ck-content" [innerHTML]="cropHtml(translatedItemFields.transportArrivalTrainStationDescription, transportDescriptionLimit)|safeHtml"></div>
                            }
                            <div class="long ck-content" [innerHTML]="translatedItemFields.transportArrivalTrainStationDescription|safeHtml"></div>
                            @if(textLength(translatedItemFields.transportArrivalTrainStationDescription) > transportDescriptionLimit) {
                                <p class="more" (click)="moreTransportInfos(startAdviceContainer)">{{ 'offer.transport.more' | translate}}</p>
                            }
                        </div>
                    }

                    @if(hasOfferLocationTransportByType('airport')) {
                        <app-core-offer-location-transport-calculation-details [offerLocationTransport]="getOfferLocationTransport(true, false, 'airport')" [displayTransportDuration]="item.displayTransportDuration"></app-core-offer-location-transport-calculation-details>
                    }

                    @if(hasOfferLocationTransportByType('airport') && textLength(translatedItemFields.transportArrivalAirportDescription) > 0) {

                        <div class="advice" #startAdviceContainer>
                            <p class="underline"><strong>{{ 'offer.transport.advice' | translate}}</strong></p>
                            @if(textLength(translatedItemFields.transportArrivalAirportDescription) > transportDescriptionLimit) {
                                <div class="short ck-content" [innerHTML]="cropHtml(translatedItemFields.transportArrivalAirportDescription, transportDescriptionLimit)|safeHtml"></div>
                            }
                            <div class="long ck-content" [innerHTML]="translatedItemFields.transportArrivalAirportDescription|safeHtml"></div>
                            @if(textLength(translatedItemFields.transportArrivalAirportDescription) > transportDescriptionLimit) {
                                <p class="more" (click)="moreTransportInfos(startAdviceContainer)">{{ 'offer.transport.more' | translate}}</p>
                            }
                        </div>
                    }

                </div>

                <!-- Fin de programme -->

                <div class="transport_infos">

                    <p class="transport_moment"><strong>{{ 'offer.access.program.end.value' | translate}}</strong></p>

                    @if(hasOfferLocationTransportByType('train-station')) {
                        <app-core-offer-location-transport-calculation-details [offerLocationTransport]="getOfferLocationTransport(false, true, 'train-station')" [displayTransportDuration]="item.displayTransportDuration"></app-core-offer-location-transport-calculation-details>
                    }

                    @if(hasOfferLocationTransportByType('train-station') && textLength(translatedItemFields.transportDepartureTrainStationDescription) > 0) {

                        <div class="advice" #endAdviceContainer>
                            <p class="underline"><strong>{{ 'offer.transport.advice' | translate}}</strong></p>
                            @if(textLength(translatedItemFields.transportDepartureTrainStationDescription) > transportDescriptionLimit) {
                                <div class="short ck-content" [innerHTML]="cropHtml(translatedItemFields.transportDepartureTrainStationDescription, transportDescriptionLimit)|safeHtml"></div>
                            }
                            <div class="long ck-content" [innerHTML]="translatedItemFields.transportDepartureTrainStationDescription|safeHtml"></div>
                            @if(textLength(translatedItemFields.transportDepartureTrainStationDescription) > transportDescriptionLimit) {
                                <p class="more" (click)="moreTransportInfos(endAdviceContainer)">{{ 'offer.transport.more' | translate}}</p>
                            }
                        </div>
                    }

                    @if(hasOfferLocationTransportByType('airport')) {
                        <app-core-offer-location-transport-calculation-details [offerLocationTransport]="getOfferLocationTransport(false, true, 'airport')" [displayTransportDuration]="item.displayTransportDuration"></app-core-offer-location-transport-calculation-details>
                    }

                    @if(hasOfferLocationTransportByType('airport') && textLength(translatedItemFields.transportDepartureAirportDescription) > 0) {

                        <div class="advice" #endAdviceContainer>
                            <p class="underline"><strong>{{ 'offer.transport.advice' | translate}}</strong></p>
                            @if(textLength(translatedItemFields.transportDepartureAirportDescription) > transportDescriptionLimit) {
                                <div class="short ck-content" [innerHTML]="cropHtml(translatedItemFields.transportDepartureAirportDescription, transportDescriptionLimit)|safeHtml"></div>
                            }
                            <div class="long ck-content" [innerHTML]="translatedItemFields.transportDepartureAirportDescription|safeHtml"></div>
                            @if(textLength(translatedItemFields.transportDepartureAirportDescription) > transportDescriptionLimit) {
                                <p class="more" (click)="moreTransportInfos(endAdviceContainer)">{{ 'offer.transport.more' | translate}}</p>
                            }
                        </div>
                    }

                </div>
            }

        </div>
    }


</div>
